exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-on .cell[data-v-4774035e]{overflow:visible;overflow-x:visible;overflow-y:visible}\n", ""]);

// exports
